import './PaperlessBanner.scss';

import React from 'react';

import Banner from 'components/shared/Banner/Banner';
import { feesAndMinimumsUrl } from 'services/Externals';
import { AAMBeaconButton } from 'components/shared/Beacon';

const GoPaperless = ({ selectAllPaperless }) => {

  return (
    <Banner className="paperless-preferences-banner" arrow={false}>
      <span className="paperless-banner-content">
        <p className="super-title">Did you know?</p>
        <p className="title">Waive your account service fee by going paperless</p>
        <p className="body">
          You may be subject to an annual account service fee of $20 for mutual
          fund accounts with a balance below $10,000, unless you meet criteria
          for a fee waiver. Selecting e-delivery for Statements, Confirmations,
          and Prospectuses/Shareholder Reports is one of the ways you can waive
          this fee.
        </p>
        <p className="learn-more-text">
          <a
            href={feesAndMinimumsUrl}
            id="document-delivery-learn-more-link"
            rel="noopener noreferrer"
            target="_blank">
            Learn more
          </a>{' '}
          about the account service fee and other ways you can get it waived.
        </p>
        <AAMBeaconButton
          className="banner-action-button"
          id={'general-section-go-paperless-button'}
          onBeaconEventClick={selectAllPaperless}
          variant={'primary'}
          scale={'normal'}
        >
          Waive Service Fee
        </AAMBeaconButton>
      </span>
    </Banner>
  );
};

export default GoPaperless;
